import type { CheckoutConfig } from '#types/config/components/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    deliveryMethod: 'subtitle-8 mb-1',
  }

} satisfies RecursivePartial<CheckoutConfig['addShippingAddress']>
